/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ActivePaymentsToArchiveDto,
  ErrorMessage,
} from '../models';
import {
    ActivePaymentsToArchiveDtoFromJSON,
    ActivePaymentsToArchiveDtoToJSON,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
} from '../models';

export interface ArchiveRequest {
    activePaymentsToArchiveDto: ActivePaymentsToArchiveDto;
}

/**
 * 
 */
export class ArchiveActivePaymentsControllerApi extends runtime.BaseAPI {

    /**
     */
    async archiveRaw(requestParameters: ArchiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.activePaymentsToArchiveDto === null || requestParameters.activePaymentsToArchiveDto === undefined) {
            throw new runtime.RequiredError('activePaymentsToArchiveDto','Required parameter requestParameters.activePaymentsToArchiveDto was null or undefined when calling archive.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/inhouse/v1/cart-payments/archive`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ActivePaymentsToArchiveDtoToJSON(requestParameters.activePaymentsToArchiveDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async archive(requestParameters: ArchiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.archiveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
